<template>
  <v-app id="inspire">
    <v-overlay v-if="loader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <template v-else>
      <template v-if="$route && $route.meta && $route.meta.layout !== 'empty'">
        <Navigation></Navigation>
        <router-view name="PrimaryNavigation" />
        <Header />
      </template>
      <div
        :style="{
          paddingLeft: shift + 'px'
        }"
      >
        <vue-extend-layouts />
      </div>
    </template>
  </v-app>
</template>

<script>
import VueExtendLayouts from "vue-extend-layout";
import Navigation from "./components/Navigation";
import Header from "./components/Header";
import axios from "axios";
export default {
  name: "App",
  components: {
    VueExtendLayouts,
    Navigation,
    Header
  },
  data: () => ({
    drawer: true,
    loader: false
  }),
  computed: {
    shift() {
      if (
        this.$vuetify.breakpoint.lgAndUp &&
        this.$route.matched[0] &&
        this.$route.matched[0].components.PrimaryNavigation
      ) {
        return 256;
      }
      return 0;
    }
  },
  methods: {
    init() {
      axios.defaults.headers.common["Accept"] = "application/json";
      this.loader = true;
      this.$store
        .dispatch("sessionStore/setToken", {
          token: localStorage.userToken || ""
        })
        .then(() => {
          let token = this.$store.getters["sessionStore/getToken"];
          this.$store.dispatch("navigationStore/setRootNavigationNode", {
            drawer: localStorage.navigation !== "false",
            url: window.location.pathname + window.location.hash
          });
          this.$store.dispatch("titleStore/setTitle", { chain: [], index: 1 });

          //If have some user
          if (token) {
            this.$store.dispatch("projectStore/getList", {
              params: { limit: -1 }
            });
            this.$store
              .dispatch("profileStore/refreshProfile", {
                drawer: localStorage.navigation !== "false",
                url: window.location.pathname + window.location.hash
              })
              .then(() => (this.loader = false));
          } else {
            this.loader = false;
          }
        });
    }
  },
  created() {
    this.$root.$on("init", () => {
      this.init();
    });
    this.init();
  }
};
</script>
